<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h1 class="mb-4">Privacy Policy</h1>
        <p class="text-muted mb-4">Last updated: September 21, 2025</p>
        
        <section class="mb-4">
          <p><strong>1. Information We Collect</strong></p>
          <p>We collect information you provide directly to us, such as when you create an account, use our services, or contact us. This may include:</p>
          <ul>
            <li>Account information (name, email address)</li>
            <li>Workflow data and form submissions</li>
            <li>Usage data and analytics</li>
          </ul>
        </section>

        <section class="mb-4">
          <p><strong>2. How We Use Your Information</strong></p>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process workflows and manage approvals</li>
            <li>Communicate with you about your account</li>
            <li>Analyze usage patterns to enhance user experience</li>
          </ul>
        </section>

        <section class="mb-4">
          <p><strong>3. Information Sharing</strong></p>
          <p>We do not sell, trade, or otherwise transfer your personal information to third parties except:</p>
          <ul>
            <li>With your explicit consent</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and safety</li>
          </ul>
        </section>

        <section class="mb-4">
          <p><strong>4. Data Security</strong></p>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
        </section>

        <section class="mb-4">
          <p><strong>5. Data Retention</strong></p>
          <p>We retain your information for as long as necessary to provide our services and comply with legal obligations. You may request deletion of your data by contacting us.</p>
        </section>

        <section class="mb-4">
          <p><strong>6. Contact Us</strong></p>
          <p>If you have any questions about this Privacy Policy, please contact us through our support channels.</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Privacy policy content - static implementation for MVP
</script>